function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListViewIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg6",
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 15.958266 H 63.833066 V 0 Z M 0,39.895666 H 63.833066 V 23.9374 H 0 Z m 0,23.9374 H 63.833066 V 47.874799 H 0 Z",
    id: "path4",
    style: {
      strokeWidth: 3.98957
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListViewIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-view-icon.3601a02c34360d060ea8a50a35ccd3c0.svg";